var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricTotalCreatorsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#FFF3E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85527,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#FFF9F2",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1674 21.7676H21.0959C19.8985 21.7676 18.8978 22.6094 18.6531 23.7335H12.0373C9.94504 23.7335 8.76915 21.4965 10.5106 20.3367C12.0726 19.2963 13.9484 18.69 15.9659 18.69C17.9834 18.69 19.8593 19.2963 21.4213 20.3367C21.8034 20.5912 22.0451 20.8975 22.1674 21.2208V21.7676Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9263 23.7335H12.0373C9.94504 23.7335 8.76915 21.4965 10.5106 20.3367C12.0726 19.2963 13.9484 18.69 15.9659 18.69C17.9834 18.69 19.8593 19.2963 21.4213 20.3367C21.7315 20.5433 21.9492 20.7841 22.0855 21.0403",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9684 16.3877C18.2468 16.3877 19.5285 15.1061 19.5285 12.8277C19.5285 10.5492 18.2468 9.26761 15.9684 9.26761C13.69 9.26761 12.4084 10.5492 12.4084 12.8277C12.4084 15.1061 13.69 16.3877 15.9684 16.3877Z",
    fill: "#F3E1CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0635 16.9986C21.2184 17.0136 21.3793 17.0211 21.5461 17.0211C23.6144 17.0211 24.7778 15.8578 24.7778 13.7895C24.7778 11.815 23.7175 10.6652 21.8218 10.565",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0635 16.9986C21.2184 17.0136 21.3793 17.0211 21.5461 17.0211C23.6144 17.0211 24.7778 15.8578 24.7778 13.7895C24.7778 11.815 23.7175 10.6652 21.8218 10.565",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9684 16.3877C18.2468 16.3877 19.5285 15.1061 19.5285 12.8277C19.5285 10.5492 18.2468 9.26761 15.9684 9.26761C13.69 9.26761 12.4084 10.5492 12.4084 12.8277C12.4084 15.1061 13.69 16.3877 15.9684 16.3877Z",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6674 20.6962V27.839M21.0959 24.2676H28.2388",
    stroke: "#DA7500",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricTotalCreatorsIcon);
export default __webpack_public_path__ + "static/media/metric_total_creators_icon.05ccaaba8db212c253135b28070c1289.svg";
export { ForwardRef as ReactComponent };